var render = function (_h,_vm) {var _c=_vm._c;return _c('b-alert',{attrs:{"show":"","variant":"warning"}},[_vm._v(" The workspace you are trying to view does not exist or you have no permissions to access. Go back to "),_c('router-link',{staticClass:"alert-link",attrs:{"to":{name:'workspaces'}}},[_vm._v("workspaces list")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }